<template>
  <div v-if="toast" class="ui-toast" role="status" aria-live="polite">
    <span>{{ toast.text }}</span>
    <button v-if="toast.action" type="button" @click="ctl.runToastAction">{{ toast.label }}</button>
  </div>
</template>

<script>
/** Kratko obavještenje na dnu stranice (računar i telefon), sa opcionom radnjom. */
export default {
  name: "RecipesToast",
  inject: { ctl: "recipesCtl" },
  computed: {
    toast() {
      return this.ctl.toast;
    },
  },
};
</script>
